import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@circle-react-uikit/Button";

export const PendingButton = () => (
  <Button variant="secondary" disabled className="flex items-center gap-x-2">
    <Icon type="16-clock" viewBox="0 0 16 16" />
    {t("profile_drawer.connect_banner.states.pending")}
  </Button>
);
